export default "__VITE_ASSET__1440b381__"